/**
 * Finishing - Tables
 *
 * JS pour la gestion des tableaux
 *
 * @since       31.07.2015
 * @version     1.0.0.1
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery( document ).ready( function() {

    /********************************/
    /********** DATA TABLE **********/
    /********************************/

    jQuery( '#sorting-data-table' ).dataTable({
        "paging": false,
        "searching": false,
        "info": false
    });
    
    /************************************/
    /********** TABLEAU EXPAND **********/
    /************************************/
    
    if ( jQuery( '.table-expand' ).length > 0 ) {
        
        jQuery( '.table-expand tr.table-hide' ).nextAll( 'tr' ).hide();
        
        jQuery( document ).on( 'click', '.table-expand .table-hide', function( event ) {
            
            event.preventDefault();
            
            jQuery( this ).nextAll( 'tr' ).fadeToggle( 'fast' );
            
            return false;
            
        //END .jQuery( document ).on( '.table-expand .table-hide .deploy-table', 'click', function() {
        });
        
    //END if ( jQuery( '.table-expand' ).length > 0 )
    }

//END jQuery( document ).ready
});
